export default __webpack_public_path__ + "ca33f72675c08f43ceca30d0fbf397ea.jpg";